const endpointConfig = {
  signIn: '/auth/login',
  signOut: '/auth/logout',
};

export default endpointConfig;
